import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from '@app/material.module';
import { DirectiveModule } from '@app/directives/directive.module';
import { SearchlistComponent } from './searchlist.component';

@NgModule({
    declarations: [SearchlistComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AngularMaterialModule,
        DirectiveModule,
    ],
    exports: [SearchlistComponent],
})
export class CruiseSearchlistModule { }
